const content = {
  close: "Close",
  title: "Downline Profile",
  back: "Go back",
  tabs: {
    performanceMetrics: "Performance Metrics",
    sopStatus: "SOP Status",
    keyInformation: "Key Information",
    notes: "Notes",
    orderHistory: "Order History",
    coupons: "Coupons",
  },
  toolbar: {
    rawView: "Table view",
    graphView: "Graph view",
    selectKpi: "Select KPI",
    export: "Export",
  },
  keyInformation: {
    awardInformation: "Award Information",
    keyDates: "Key Dates",
    additionalInformation: "Additional Information",
    applicants: "Applicants",
    sponsors: "Sponsors",
    corePlusIncentiveStatus: "Core Plus Incentive Status",
    coursesCompleted: "Courses Completed",
    awardInformationEmpty: "This information is not available due to the current pin level of this user.",
    corePlusIncentive: "Core Plus Incentive Status",
    awardLabels: {
      previousAward: "PY{date} Award Level",
      trackingAward: "PY{date} Tracking Award Level",
      highestAward: "Highest Award Level",
      currentAward: "PY{date} Current Award Level",
      bronze: "Bronze",
      silver: "Silver",
      gold: "Gold",
      basePYDate: "PY{date}",
    },
    keyDatesLabels: {
      birthday: "Birthday",
      renewal: "Renewal/Expiration Date",
      entry: "Entry Date",
      recentSponsoring: "Recent Sponsoring Date",
      recentOrder: "Recent Order Date",
      currentBusinessEffectiveDate: "Current Business Effective Date",
      businessAnniversaryDate: "Business Anniversary Date",
    },
    additionalInformationLabels: {
      orderBlock: "Order Block",
      sponsorBlock: "Sponsor Block",
      autoRenewal: "Auto Renewal",
      contractSigned: "Contract Signed",
      renewalConsent: "Renewal Consent",
      couponConsent: "Coupon Consent",
      yes: "Yes",
      no: "No",
    },
    applicantActions: {
      showMore: "Show More",
      showLess: "Show Less",
      primary: "Primary",
      coApplicant: "Co Applicant",
    },
    sponsorTags: {
      sponsor: "Sponsor",
      sponsorPlatinum: "Sponsor & Platinum",
      platinum: "Platinum",
      fosterSponsor: "Foster Sponsor",
      fosterSponsorPlatinum: "Foster Sponsor & Platinum",
      internationalSponsor: "International Sponsor",
    },
    corePlusIncentiveLabels: {
      pathToBronze: "Path to Bronze Incentive",
      bronzeFoundation: "Bronze Foundation Incentive",
      bronzeBuilder: "Bronze Builder Incentive",
      ssi: "SSI",
      graduated: "Graduated",
      started: "Started",
      notStarted: "Not Started",
    },
  },
  onSop: "On SOP",
  onAutoRenewal: "On Auto Renewal",
  notesTag: "Notes",
  highestAward: "PY{py_2_digit} Highest Award",
  platinumOrAbove: "Platinum or above",
  viewTheirLOS: "View their LOS",
  sponsorInformation: "Sponsor Information",
  phoneCall: "Phone Call",
  sms: "Send SMS",
  whatsApp: "Send WhatsApp message",
  copyPhone: "Copy phone number",
  copyEmail: "Copy Email Address",
  email: "Send email",
  uplineLos: "Upline LOS",
  closeLineage: "Close lineage",
  watchlist: {
    added: "{name} added to your Watchlist.",
    removed: "{name} removed from your Watchlist.",
    error: "Something went wrong. Please try again.",
  },
  trendChart: {
    legendPyLabel: "PY{year}",
    chartAriaLabel: "{metric} trend by performance year",
    emptyMessage: "There is no data available for the selected performance year.",
    loadingAria: "Loading chart",
    scale: {
      thousands: "Thousands",
      millions: "Millions",
      billions: "Billions",
      trillions: "Trillions",
    },
    screenReader: {
      dataTableCaption: "{metric} by month and performance year",
      monthColumnHeader: "Month",
      noValue: "No data",
    },
  },
  performanceMetrics: {
    personalPV: "Personal PV",
    groupPV: "Group PV",
    vcsPV: "VCS PV",
    personalVcsPercent: "VCS %",
    customerPV: "Customer PV",
    personalOrders: "Personal Orders",
    groupOrders: "Group Orders",
    sponsoring: "Sponsoring",
    groupSize: "Group Size",
    leadershipPV: "Leadership PV",
    rubyPV: "Ruby PV",
    newPersonalCustomers: "New Personal Customers",
    personalCustomerOrders: "Personal Customer Orders",
    totalPersonalCustomers: "Total Personal Customers",
    performanceBonus: "Performance Bonus %",
    personalPVAbbr: "PPV",
    groupPVAbbr: "GPV",
    leadershipPVAbbr: "LPV",
    rubyPVAbbr: "RPV",
    customerPVAbbr: "CPV",
    vcsPVAbbr: "VCS PV",
    personalVcsPercentAbbr: "VCS %",
    performanceBonusAbbr: "PB",
    versusDate: "vs {date}",
    lastClosedMonth: "Last closed month, {date}",
    lastProcessedMonth: "Last month processed - {date}",
  },
  notes: {
    noteLastEdit: "Last Edit {timestamp_MMDDYY_HHMMSS}",
    edit: "Edit",
    delete: "Delete",
    noNotes: "No notes created.",
    addNote: "Add New Note",
    intoText:
      "These notes are only visible for you. People within your LOS will not be able to see your personal notes.",
    editor: {
      normalText: "Normal",
      heading1: "Heading 1",
      heading2: "Heading 2",
      heading3: "Heading 3",
      undo: "Undo",
      redo: "Redo",
      bold: "Bold",
      italic: "Italic",
      strikethrough: "Strikethrough",
      underline: "Underline",
      superscript: "Superscript",
      subscript: "Subscript",
      alignLeft: "Align left",
      alignCenter: "Align center",
      alignRight: "Align right",
      bulletedList: "Bulleted list",
      numberedList: "Numbered list",
      placeholder: "Add a note...",
      save: "Save",
      cancel: "Cancel",
    },
    deleteModal: {
      title: "Delete note?",
      description: "Are you sure you want to delete this note? This action is permanent and cannot be undone.",
      cancelButton: "Cancel",
      confirmButton: "Confirm",
    },
    toastMessage: {
      noteAdded: "Note successfully added.",
      noteUpdated: "Note successfully updated.",
      noteDeleted: "Note successfully deleted.",
    },
  },
  pdfExport: {
    performanceMetricsTable: "Performance Metrics - Table View",
    performanceMetricsTableContinued: "Performance Metrics - Table View Continued",
    performanceMetricsGraph: "Performance Metrics - Graph View",
    performanceMetricsGraphContinued: "Performance Metrics - Graph View Continued",
    export: "Export",
    cancel: "Cancel",
    exportText: "Export Downline Profile",
    downloadText: "Download a PDF of this downline profile.",
    exportProfile: "Export Personal Profile",
    downloadProfile: "Download a PDF of my personal profile.",
  },
  sopStatus: {
    tiles: {
      productsOnSop: "Products on SOP",
      productsShippingThisMonth: "Products shipping this month",
      ordersUpForRenewal: "SOP orders up for renewal",
      expectedPVThisMonth: "Expected SOP PV this month",
      expectedPVNextMonth: "Expected SOP PV next month",
    },
    sopProductInfo: "SOP Product Information",
    promoMonth: "Promotional Month",
    expiryMonth: "Expiry Month",
    upForRenewal: "SOP up for Renewal",
    startDate: "Start Date",
    expiryDate: "Expiry Date",
    monthlySopPv: "Monthly SOP PV",
    frequencySchedule: "Frequency Schedule",
    productsContinued: "SOP Products - continued",
  },
  comingSoon: {
    sopStatus: "SOP information coming soon!",
    coupons: "Coupon information coming soon!",
  },
} as const;

export default content;
